export default "__VITE_ASSET__4qO4V$WX__"